const type = 'advanced'
const path = '/advance/react-node/advanced-integration/src/'
const name = 'index.js'

export { type, path, name }
